import * as React from 'react';

const CalendarRepeatSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="calendar-repeat_svg__eds-icon--calendar-repeat_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="calendar-repeat_svg__eds-icon--calendar-repeat_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 4V2h-1v2H8V2H7v2H2v18h20V4h-5zm4 17H3V9h18v12zM3 8V5h4v1h1V5h8v1h1V5h4v3H3z"
        />
        <path
            id="calendar-repeat_svg__eds-icon--calendar-repeat_arrow"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2 13c-.5-.6-1.3-1-2.2-1-1.7 0-3 1.3-3 3s1.3 3 3 3c.7 0 1.3-.2 1.8-.6l.6.8c-.7.5-1.5.8-2.4.8-2.2 0-4-1.8-4-4s1.8-4 4-4c1.2 0 2.3.5 3 1.4V11h1v3h-3v-1h1.2z"
        />
    </svg>
);

CalendarRepeatSvg.displayName = 'CalendarRepeatSvg';
export default CalendarRepeatSvg;
